import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "messages",
  "use": "messages-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"messages\"><path d=\"M5.2 10.2L16 1.5 0 8zm1 4.3v-3.6L16 1.5l-4.4 12.8-4-2.9z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/messages.svg
// module id = 2svZ
// module chunks = 39 44